import React, { useState } from 'react';
import './MobileNavbar.css';
import Logo from './assets/download.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import { getState } from './Firebase/auth';
import { motion, useScroll, useTransform, cubicBezier, useSpring } from 'framer-motion';
import { ShoppingBag, User, LogIn } from 'lucide-react';
import ShopBrand from './Business/ShopBrand';

export default function MobileNavBar({ sidebar, setSideBar, footerLogoOpacity }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const { scrollY } = useScroll();
  const smoothScrollY = useSpring(scrollY, { damping: 20, stiffness: 90 });
  const logoScale = 1;
  const logoY = '0vh';
  const contentOpacity = 1;
  const isHome = location.pathname === '/';

  const accountClick = () => {
    if (getState()) {
      navigate('/profile');
    } else {
      navigate('/login');
    }
  };

  const toggleMobileMenu = () => {
    setSideBar(!sidebar);
  };

  return (
    <div className="MobileNavBar">
      <div className="nav-mobile-header">
        <motion.button onClick={toggleMobileMenu} className="nav-mobile-premium-burger" aria-label="Open menu" style={isHome ? { opacity: contentOpacity } : {}}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="12" x2="15" y2="12"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </motion.button>
        <ShopBrand small>
          <motion.img
            src={Logo}
            alt="Logo"
            className="nav-mobile-logo"
            onClick={() => {
              navigate('/');
            }}
            style={isHome ? { opacity: footerLogoOpacity } : undefined}
          />
        </ShopBrand>



        <button type="button" className="nav-mobile-bag" onClick={() => navigate('/cart')} aria-label="Bag">
          <ShoppingBag size={22} strokeWidth={1.5} />
        </button>
      </div>
    </div>
  );
}
